<div class="table-responsive data-grid mt-3 sticky-header-table sticky-header-table-height-md" #tableBusiness>
  <table mat-table
         class="table table-hover"
         matSort="businessSort" [dataSource]="dataSource"
         infiniteScroll
         [infiniteScrollDistance]="2"
         [infiniteScrollThrottle]="20"
         [infiniteScrollContainer]="tableBusiness"
         [fromRoot]="true"
         [trackBy]="trackByBusiness"
         (scrolled)="onTableScroll()">
    <ng-container matColumnDef="businessName">
      <th mat-header-cell mat-sort-header
          class="business-name-heading cursor-pointer"
          *matHeaderCellDef>
        Name <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.businessName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="address">
      <th mat-header-cell mat-sort-header
          class="address-heading cursor-pointer"
          *matHeaderCellDef>
        Address<i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="address-section">
          {{ element.address }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="addressLine2">
      <th mat-header-cell mat-sort-header
          class="address-heading cursor-pointer"
          *matHeaderCellDef>
        Address 2 <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="address-section">
          {{ element.addressLine2 }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="suburb">
      <th mat-header-cell mat-sort-header
          class="suburb-heading cursor-pointer"
          *matHeaderCellDef>
        Suburb <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="suburb-section">
          {{ element.suburb }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="stateName">
      <th mat-header-cell mat-sort-header
          class="statename-heading cursor-pointer"
          *matHeaderCellDef>
        State <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="statename-section">
          {{ element.stateName }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="postCode">
      <th mat-header-cell mat-sort-header
          class="postCode-heading cursor-pointer"
          (click)="sortTable(RepoBusinessTableFields.POSTCODE)"
          *matHeaderCellDef>
        Post Code <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="postCode-section">
          {{ element.postCode }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="countryName">
      <th mat-header-cell mat-sort-header
          class="country-heading cursor-pointer"
          *matHeaderCellDef>
        Country <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="country-section">
          {{ element.countryName }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="website">
      <th mat-header-cell mat-sort-header
          class="website-heading cursor-pointer"
          (click)="sortTable(RepoBusinessTableFields.WEBSITE)"
          *matHeaderCellDef>
        Website <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element"><a target="_blank" [href]="sanitizeUrl(element.website)">{{ element.website }}</a></td>
    </ng-container>
    <ng-container matColumnDef="contacts">
      <th mat-header-cell mat-sort-header
          class="contacts-heading cursor-pointer"
          *matHeaderCellDef>
        Contacts <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.contacts">
          <ng-container *ngFor="
                            let contact of element.contacts;
                            let i = index
                          ">
            <ng-container>
              <span (click)="openAddPopup(element, true)" *ngIf="i >= 3 && i === (element.contacts.length - 1)" class="contact-box contact-box-3 cursor-pointer">+{{element.contacts.length - 3}}</span>
              <span (click)="openAddPopup(element, false,contact.repoContactId)" *ngIf="i < 3"
                    ngbTooltip="{{ contact.fullName }}"
                    class="cursor-pointer contact-box contact-box-{{ i }}">{{ contact.prefix }}</span>
            </ng-container>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="options">
      <th style="text-align:right;padding-right:55px"
          mat-header-cell
          class="options-heading cursor-pointer"
          *matHeaderCellDef>
        Action
      </th>
      <td mat-cell *matCellDef="let element" style="text-align:right">
        <a class="btn btn-outline-primary btn-sm me-1"
           (click)="openAddPopup(element, false)"
           title="Add Contact">
          <i class="fa fa-plus"></i>
        </a>
        <span class="divider"></span>
        <a style="width:32px"
           class="btn btn-outline-primary btn-sm me-1"
           (click)="openAddPopup(element, true)"
           title="View Contacts">
          <i style="font-size: 16px;margin-top: 1px;margin-left: -1px;" class="fa fa-address-book"></i>
        </a>
        <span class="divider"></span>
        <a class="btn btn-outline-primary btn-sm"
           (click)="openRepoBusinessPopup(element)"
           title="Edit {{OrgTitle}}">
          <i class="far fa-edit"></i>
        </a>
        <button type="button" class="btn btn-outline-primary btn-sm ms-1"
                (click)="DeleteRepoBusiness(element)"
                title="Delete {{OrgTitle}}">
          <i class="fa fa-trash"></i>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
    <tr mat-row
        *matRowDef="
                        let row;
                        columns: displayedColumns$.value;
                        let saleIndex = index
                      "
        class="border-start-0 border-end-0 pointer pt-2"></tr>
  </table>
</div>

